import TableStyles from "../../../styles/TableStyles.css";
import CommonStyles from "../../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...TableStyles,
  ...CommonStyles,

  globalBlock: {
    marginBottom: "10px",
    "& > div": {
      padding: "5px 30px",
    },
    "& button.MuiButton-text": {
      margin: "15px 0",
    },
  },

  moduleEdit: {
    float: "right",
    minWidth: "30px",
    background: "#212121",
    padding: "8px",
  },
  sidBarWrap: {
    // minWidth: "480px",
    position: "relative",
    overflow: "hidden",
    height: "100%",
    background: "#303030",
  },

  sidBarInnerWrap: {
    left: " 0",
    width: "100%",
    height: "calc(100% - 0px)",
    position: "absolute",
    overflowX: "hidden",
    overflowY: "auto",
  },
  sidBarInnerContents: {
    padding: "20px",
  },
  toolsInnerWrap: {
    background: "#636363",
    borderRadius: "5px",
    marginRight: "5px",
    float: "left",
    padding: "3px 5px",
    minWidth: "230px",
     fontSize:"0.8em",
    marginLeft:"6px",
    "& div:before": {
      outline: "none",
      border: "none !important",
      width: "100%",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "2px solid #0C853E",
    },
    "& div": {
      width: "100%",
    },
    "& input": {
      width: "100%",
      padding: "5px 8px",
       fontSize:"0.8em",
      fontWeight: "300",
    },
  },
  tableMainView: {
    overflow: "auto",
    width: "100%",
    marginTop: "52px",
    background: "#000",
    position: "absolute",
    height: "calc(100% - 59px)",
    "& .MuiAvatar-square":{
      width:"22px",
      height:"22px",
      background: "#d8d8d5",
      borderRadius: "3px",
    },
    "& .playTrack": {
      top: "12px",
  }
  },
  clearanceButtonMargin:{
    fontSize:"12px",
  },
  tableArtwork:{
    backgroundColor: "#b8ced2",
  },
  clearanceFilter: {
    float: "left",
    "& button": {
      float: "none",
      fontSize: "12px",
    },
  },
  clearanceViewIcon: {
    fontSize: "20px",
    marginRight: "8px",
  },
  clearanceStatusButton: {
    background: "#333",
    margin: "0 6px 0 10px",
  },
  clearanceSign: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "50%",
    margin: "5px 10px 5px 0px",
    display: "inline-block",
    verticalAlign: "middle",
  },
  clearanceOverride: {
    padding: "0 5px",
    marginBottom: "8px",
    "& label": {
      fontSize: "12px",
      margin: "8px 0 7px 0",
      display: "block",
    },
    "& .MuiSelect-select":{
      paddingTop: "4px",
    paddingBottom: "4px",
    maxWidth:"150px",
    }
  },
  clearanceViewIcon:{
      fontSize: "20px",
      marginRight: "0",
},
clearanceStatusButton:{
  background:"#333",
  margin: "0 6px",
  minWidth: "inherit",
},
inlineWizardLinkArtist:{
  background:"#333",
},

externalClearanceButton:{
  marginBottom: "15px",
  "& > li":{
    marginTop:"5px !important",
    width:"auto !important",
  }
},
userClBlocks:{
  width:"280px",
  fontSize:"1em",
  "& input":{
    padding:"7.5px 10px 7.5px 38px !important",
    fontSize:"0.75em",
  },
  "& label":{
    fontSize:"1em",
    top: "-4px",
  }
},
toolTipSpan:{
  "&:focus":{
    outline:"none",
    "& .MuiListItem-root.Mui-disabled":{
      background:"none",
    },
    "& .MuiListItem-root":{
      background:"rgba(255, 255, 255, 0.08)"
    },     
  }
}
});
